export function appendTrackingParamsToUrl(link: string, id) {
  return link + '?trk_element_id=' + id;
}
